<template>
  <div class="w-full">
    <div id="fund-credit-card-card-number-input" class="w-full flex items-center card p-2">
      <div class="w-full card-frame" ref="card"></div>
    </div>
    <span class="text-danger text-sm block mt-2" v-if="errors.any('checkout-input')">{{ errorMsg }}</span>
  </div>
</template>

<script>
import LoadExternalScript from '@/helpers/loadExternalScript'

export default {
  props: ['cardHolderName'],
  data () {
    return {
      cardFieldName: 'card-number',
      cardFieldScope: 'checkout-input',
      emptyInput: 'empty-input'
    }
  },
  computed: {
    errorMsg () {
      const error = this.errors.items.find((el) => el.scope === this.cardFieldScope)

      return error ? error['msg'] : ''
    }
  },

  async mounted () {
    await LoadExternalScript(window.speakol_configs.checkout_payment_frame_cdn)
    await window.Frames.init({
      publicKey: window.speakol_configs.checkoutPublicKey,
      style: {
        placeholder: {
          base: {
            color: '#BFBFBF',
            fontSize: '14px'
          }
        }
      }
    })

    window.Frames.addEventHandler(
      window.Frames.Events.FRAME_VALIDATION_CHANGED,
      this.onValidationChanged
    )
  },

  methods: {
    async getToken () {
      let card = null
      this.errors.remove(`${this.cardFieldScope}.${this.emptyInput}`)
      try {
        window.Frames.cardholder = {
          name: this.cardHolderName
        }

        card = await window.Frames.submitCard()
        return card.token
      } catch (Error) {
        this.errors.add({
          scope: this.cardFieldScope,
          field: this.emptyInput,
          msg: this.getErrorMessage(this.emptyInput)
        })
      }
    },

    onValidationChanged (event) {
      if (!['card-number', 'expiry-date', 'cvv'].includes(event.element)) {
        event.element = this.emptyInput
      }
      this.errors.clear(this.cardFieldScope)

      if (!event.isValid && !this.errors.has(event.element)) {
        this.errors.add({
          scope: this.cardFieldScope,
          field: event.element,
          msg: this.getErrorMessage(event.element)
        })
      }
    },

    getErrorMessage (element) {
      return {
        'empty-input': this.$t('advertisers_fund.fund.validation.empty_input'),
        'card-number': this.$t('advertisers_fund.fund.validation.invalid_card'),
        'expiry-date': this.$t('advertisers_fund.fund.validation.invalid_expiry_date'),
        'cvv': this.$t('advertisers_fund.fund.validation.invalid_cvv')
      }[element]
    }
  }
}
</script>

<style lang="scss" scoped>
$borderColor: #d8d8d8;

.card {
  border: 1px solid $borderColor;
  border-radius: 4px;
  height: 40px;
}
</style>
